
import { Tbl_sostituzioneEdit } from './tbl_sostituzioneEdit';
import { Tbl_sostituzioneList } from './tbl_sostituzioneList';
import { Tbl_sostituzioneShow } from './tbl_sostituzioneShow';
import { Tbl_sostituzioneCreate } from './tbl_sostituzioneCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_sostituzioneList,
    edit: Tbl_sostituzioneEdit,
    show: Tbl_sostituzioneShow,
    create: Tbl_sostituzioneCreate,
    icon: MapIcon
};
            